import React from 'react';
import { FiEdit } from 'react-icons/fi';
import { asyncSimpleModal, openNewWindow, reDirectPage, setDash, setDetailPageUrl } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import OpenVersionDetail from '../../../../components/link/OpenVersionDetail/OpenVersionDetail';
import Anchor from '../../../../components/link/Anchor';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import { VERSION_FORCE_UPDATE_TEXT, VERSION_TYPE_TEXT } from '../../../../constants/service/app/versionConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { VERSION_EDIT_URL_PATH } from '../../../../constants/service/common/urlConstants';

const columns = (props) => {
  const { sortOption } = props;

  return [
    {
      title: <TableColumnTitle title={'수정'} />,
      dataIndex: 'edit',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(VERSION_EDIT_URL_PATH, record.id),
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'ID'} />,
      dataIndex: 'versionId',
      sorter: true,
      sortOrder: sortOption['versionId'],
      render: (value) => <OpenVersionDetail text={value} versionId={value} />,
    },
    {
      title: <TableColumnTitle title={'타입'} />,
      dataIndex: 'type',
      render: (value) => VERSION_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'서비스 버전'} />,
      dataIndex: 'serviceVer',
      sorter: true,
      sortOrder: sortOption['serviceVer'],
      render: (value) => value,
    },
    {
      title: <TableColumnTitle title={'제품 버전 코드'} />,
      dataIndex: 'code',
      sorter: true,
      sortOrder: sortOption['code'],
      render: (value) => value,
    },
    {
      title: <TableColumnTitle title={'강제 업데이트 여부'} />,
      dataIndex: 'forceUpdate',
      render: (value) => VERSION_FORCE_UPDATE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'마일스톤'} />,
      dataIndex: 'milestone',
      sorter: true,
      sortOrder: sortOption['milestone'],
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'스프린트'} />,
      dataIndex: 'sprint',
      sorter: true,
      sortOrder: sortOption['sprint'],
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'마켓에 등록한 날짜'} />,
      dataIndex: 'marketRegisterDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'릴리즈 날짜'} />,
      dataIndex: 'releaseDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'Jira 버전 주소'} />,
      dataIndex: 'jiraUrl',
      render: (value) => (value ? <Anchor color="primary" onClick={() => openNewWindow(value)} text={value} /> : '-'),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      render: (value) =>
        value ? (
          <Anchor
            color="primary"
            isUnderLine={true}
            text={'내용 보기'}
            onClick={async () => {
              await asyncSimpleModal({
                type: 'info',
                title: '메모 내용',
                message: setDash(value),
              });
            }}
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'생성 일자'} />,
      dataIndex: 'createDate',
      sorter: true,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'수정 일자'} />,
      dataIndex: 'updateDate',
      sorter: true,
      sortOrder: sortOption['updateDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
